// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textfield/Controlled.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextField } from '@sail/ui';
export const Controlled = () => {
  const [textValue, setTextValue] = React.useState();
  return <TextField value={textValue} onChange={e => {
    setTextValue(e.target.value); // eslint-disable-next-line no-console

    console.log(e.target.value);
  }} label="First name" />;
};